module.exports = __webpack_public_path__ + "img/logo.23232c9f.png";